import {
    Avatar,
    Button,
    Icon,
    ListItemIcon,
    ListItemText,
    Popover,
    MenuItem,
    Typography,
} from '@material-ui/core';
import {connect} from 'react-redux';
import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import classNames from 'classnames';
import ReduxUser from '../store/actionreducers/auth/user';
import {bindActionCreators} from 'redux';
import {FuseAnimate} from '@fuse';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '100%'
    },
    seperator: {
        width: 1,
        height: 64,
        backgroundColor: theme.palette.divider
    },
    logout: {
        right: '3px',
    }
});

class MainToolbar extends Component {
    state = {
        userMenu: null
    };

    userMenuClick = event => {
        this.setState({userMenu: event.currentTarget});
    };

    userMenuClose = () => {
        this.setState({userMenu: null});
    };

    logout = () => {
        this.props.logout();
        this.userMenuClose();
    };

    render() {
        const {classes, user} = this.props;
        const {userMenu} = this.state;

        return (
            <div className={classNames(classes.root, "flex flex-row")}>

                <div className="flex flex-1">
                </div>

                <div className="flex">
                    {/*<FuseAnimate delay={300}>*/}

                    {/*    <Button className="h-64" href="https://eversign.com/" target="_blank">*/}
                    {/*        <div className="hidden md:flex flex-col ml-12 items-start">*/}
                    {/*            <Typography component="span" className="normal-case font-500 flex">*/}
                    {/*                線上簽約*/}
                    {/*            </Typography>*/}
                    {/*        </div>*/}

                    {/*        <Icon className="text-16 ml-12 hidden sm:flex" variant="action">assignment</Icon>*/}
                    {/*    </Button>*/}
                    {/*</FuseAnimate>*/}
                    <FuseAnimate delay={300}>
                        <Button className="h-40-center" onClick={this.userMenuClick}>
                            {user.data.photoURL ?
                                (
                                    <Avatar className="" alt="user photo" src={user.data.photoURL}/>
                                )
                                :
                                (
                                    <Avatar className="">
                                        {user.data.displayName[0]}
                                    </Avatar>
                                )
                            }

                            <div className="hidden md:flex flex-col ml-12 items-start">
                                <Typography component="span" className="normal-case font-500 flex">
                                    {user.data.displayName}
                                </Typography>
                                <Typography className="text-11 capitalize" color="textSecondary">
                                    {user && user.roleObj && user.roleObj.name}
                                </Typography>
                            </div>

                            <Icon className="text-16 ml-12 hidden sm:flex" variant="action">keyboard_arrow_down</Icon>
                        </Button>
                    </FuseAnimate>

                    <Popover
                        open={Boolean(userMenu)}
                        anchorEl={userMenu}
                        onClose={this.userMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}
                        classes={{
                            paper: classes.logout
                        }}
                    >

                        <React.Fragment>
                            <MenuItem onClick={this.logout}>
                                <ListItemIcon>
                                    <Icon>exit_to_app</Icon>
                                </ListItemIcon>
                                <ListItemText className="text-center" primary="登出"/>
                            </MenuItem>
                        </React.Fragment>

                    </Popover>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        logout: ReduxUser.ActionCreator.logoutUser
    }, dispatch);
}

function mapStateToProps({auth}) {
    return {
        user: auth.user
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(MainToolbar));



// WEBPACK FOOTER //
// ./src/main/MainToolbar.js